import React, { useState, useEffect, useMemo, useCallback } from "react";
import RawHoney from "../../assets/images/subcat-images/honey-wooden-table-min.jpg";
import SemiProcessedHoney from "../../assets/images/semi-processed-honey.jpg";
import ProcessedHoney from "../../assets/images/honey.jpg";
import Title from "../../components/titles/Title";
import FilterSort from "../../components/FilterSort/FilterSort";
import { useParams } from "react-router-dom";
import MainService from "../../common/MainService";
import { NavHashLink } from "react-router-hash-link";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Banner from "../../components/banner/Banner";
import ManufacturerBenefits from "../../components/ManufacturerBenefits/ManufacturerBenefits";
export default function Honey() {
  // Retrieve the 'subId' from the URL parameters
  const { subId } = useParams();

  // Set initial state values
  const [getCatId] = useState("AGR11-100A"); // Category ID for Honey products
  const [loding, setLoading] = useState(true); // Loading state
  const [getHoneyProducts, setHoneyProducts] = useState([]); // State to store honey products
  const [subCategory, setSubCategory] = useState([]); // State to store subcategories
  const [getSubCategoryValue, setSubCategoryValue] = useState("Raw_Honey"); // Default subcategory value

  // Update subcategory value whenever 'subId' changes
  useMemo(() => {
    setSubCategoryValue(subId);
  }, [subId]);

  // Fetch the list of subcategories from the API
  const getAllSubCategory = () => {
    MainService.getSubCategories(window.livasaConfig.user, "AGR11-100A")
      .then((res) => {
        setSubCategory(res.contentsubcategories);
      })
      .catch((e) => {
        console.log("Error fetching subcategories:", e);
      });
  };

  // Function to fetch all products of a particular category and user
  const getAllProductsHandler = useCallback(() => {
    MainService.getAllProductsofUser(window.livasaConfig.user, getCatId)
      .then((res) => {
        const filteredData = res.filter((e) => {
          return (
            e.status === "Listed" &&
            e.consumeradminid === window.livasaConfig.user.toLowerCase()
          );
        });
        setHoneyProducts(filteredData); // Set filtered products
        setLoading(false); // Set loading to false after fetching
      })
      .catch((err) => {
        console.log("Error fetching all products:", err);
      });
  }, [getCatId]);

  // Function to fetch products based on subcategory value
  const getProductsHandler = useCallback(() => {
    MainService.productModelBasedonSubcategory(
      getCatId,
      getSubCategoryValue,
      window.livasaConfig.user
    )
      .then((res) => {
        const filteredData = res.filter((e) => {
          return (
            e.status === "Listed" &&
            e.consumeradminid === window.livasaConfig.user.toLowerCase()
          );
        });
        setHoneyProducts(filteredData); // Set filtered products
        setLoading(false); // Set loading to false after fetching
      })
      .catch((err) => {
        console.log("Error fetching products based on subcategory:", err);
      });
  }, [getCatId, getSubCategoryValue]);

  // Trigger product fetching based on subcategory value and category ID
  useEffect(() => {
    if (getSubCategoryValue === "allProducts") {
      getAllProductsHandler(); // Fetch all products if subcategory is 'allProducts'
    } else {
      getProductsHandler(); // Fetch products based on selected subcategory
    }
    getAllSubCategory(); // Always fetch subcategories when the component loads
  }, [
    getCatId,
    getSubCategoryValue,
    getProductsHandler,
    getAllProductsHandler,
  ]);

  // Set the selected subcategory value
  const subCatHandler = (val) => {
    setSubCategoryValue(val);
  };

  // Map subcategory names to corresponding image URLs
  const subcategoryImageMapping = {
    "Processed-Honey": ProcessedHoney,
    "Semi-Processed-Honey": SemiProcessedHoney,
    "Raw-Honey": RawHoney,
  };

  // Default image URL in case there is no specific mapping
  const defaultImageUrl = RawHoney;

  return (
    <>
      {/* Banner displaying title and description */}
      <Banner
        className="product-bg text-white"
        bannerTitle={[
          <span key="1">Buy Quality Organic Produce </span>,
          <br key="2" className="d-lg-block d-none"></br>,
          <span key="3">at the best price</span>,
        ]}
      />

      <div className="container collection-container">
        {/* Title for the collections section */}
        <Title heading="Collections" classname="mb-5" />

        <Row>
          {/* Render each subcategory */}
          {subCategory.map((data, index) => {
            const imageUrl =
              subcategoryImageMapping[data.contentsubcategoryname] ||
              defaultImageUrl; // Map subcategory to image

            return (
              <Col md={6} lg={3} key={index}>
                {/* Navigation link for each subcategory */}
                <NavHashLink
                  key={data.contentsubcategoryname}
                  to="#products"
                  onClick={() => subCatHandler(data.contentsubcategoryname)} // Set the selected subcategory
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  <div className="card-container">
                    <div className="card-image-container mb-4">
                      <img src={imageUrl} alt={data.contentsubcategoryname} />
                    </div>
                    <div>
                      <h5 className="text-center">
                        {data.contentsubcategoryname}
                      </h5>
                    </div>
                  </div>
                </NavHashLink>
              </Col>
            );
          })}
        </Row>

        {/* Title for the products section */}
        <div className="pt-5" id="products"></div>
        <Title heading="Products" classname="mb-5 pt-5" />

        {/* Filter and sort the products */}
        <FilterSort obj={getHoneyProducts} loadValue={loding} />
      </div>

      <div className="section-container benefit-container">
        <div className="container">
          {/* Title for the benefits section */}
          <Title classname="text-center mb-5" heading="Benefits" />
          <ManufacturerBenefits />
        </div>
      </div>
    </>
  );
}
